import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Auth } from 'aws-amplify';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

import Header from '../Components/Header'
import TabPanelEmployee from '../Components/TabPanelEmployee'
import TabPanelAdminBHSS from '../Components/TabPanelAdminBHSS'
import { getFeedbackByUser } from '../services/UserService'

function MainView({ signOut }) {
  const [value, setValue] = useState(0);
  const [userGroup, setUserGroup] = useState('');

  useEffect(() => {
    getUserData();
    sendFeedbackRequest();
  }, []);

  const sendFeedbackRequest = async () => {
    await getFeedbackByUser("103189")
  };

  const getUserData = async () => {
    let groupNr = 0;
    let user = await Auth.currentAuthenticatedUser();
    groupNr = user.attributes.locale;
    setUserGroup(groupNr);
  };

  const ShowTab = () => {
    // Only the admin group ('1') has more than one destination, so it's the only
    // group that benefits from a tab list. Other groups always show a single view.
    if (userGroup !== '1') {
      return null;
    }

    const tabs = [
      { label: '2C' },
      { label: '2D' },
      { label: '2E' },
      { label: '1A' },
      { label: '1B' },
      { label: 'TEST' },
      { label: 'Pasienter', icon: <GroupOutlinedIcon /> },
      { label: 'Ansatte', icon: <PersonOutlineIcon /> },
      { label: 'Evaluering', icon: <AssessmentOutlinedIcon /> },
    ];

    return (
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Navigasjon"
        sx={{
          width: '100%',
          paddingTop: 10,
          '& .MuiTabs-flexContainer': {
            gap: 0.5,
            height: 'auto',
          },
          '& .MuiTabs-scroller': {
            overflow: 'visible !important',
            flexGrow: 0,
            height: 'auto',
          },
          '& .MuiTabs-indicator': {
            display: 'none',
          },
          '& .MuiTab-root': {
            minHeight: 40,
            minWidth: 0,
            width: 'calc(100% - 20px)',
            margin: '0 10px',
            padding: '0 10px',
            boxSizing: 'border-box',
            overflow: 'visible',
            whiteSpace: 'nowrap',
            justifyContent: 'flex-start',
            alignItems: 'center',
            borderRadius: '10px',
            color: 'rgba(255, 255, 255, 0.88)',
            fontSize: 13,
            fontWeight: 500,
            textTransform: 'none',
          },
          '& .MuiTab-root:nth-of-type(7)': {
            marginTop: 0,
            minHeight: 52,
            paddingTop: 2,
            position: 'relative',
          },
          '& .MuiTab-root:nth-of-type(7)::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            borderTop: '1px solid rgba(255, 255, 255, 0.35)',
          },
          '& .MuiTab-root.Mui-selected': {
            color: '#17617A',
            bgcolor: '#FFFFFF',
            fontWeight: 700,
          },
          '& .MuiTab-root.MuiTab-labelIcon': {
            flexDirection: 'row',
            gap: 2,
          },
          '& .MuiTab-root .MuiTab-iconWrapper': {
            margin: 0,
          },
          '& .MuiSvgIcon-root': {
            fontSize: 19,
          },
        }}
      >
        {tabs.map(({ label, icon }, index) => (
          <Tab
            key={index}
            label={label}
            icon={icon}
            iconPosition="start"
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  return (
    <Box sx={{ flexDirection: 'row', flexGrow: 1, minHeight: '100vh', bgcolor: 'background.paper', display: 'flex' }}>
      {userGroup === '1' && (
        <Box sx={{ bgcolor: '#51B7CE', minHeight: '100vh', width: 140, flexShrink: 0, paddingTop: 2 }}>
          <ShowTab />
        </Box>
      )}
      <Box sx={{ flexDirection: 'column', minWidth: 0, minHeight: '100vh', width: '100%', display: 'flex' }}>
        <Header signOut={signOut} title={userGroup === '1' ? 'Admin' : `Gruppe ${userGroup}`} />
        {userGroup === '1' && <TabPanelAdminBHSS value={value} />}
        {(userGroup === '1B' || userGroup === '1A' || userGroup === '2C' || userGroup === '2D' || userGroup === '2E' || userGroup === 'TEST') && <TabPanelEmployee value={value} userGroup={userGroup} />}
      </Box>
    </Box>
  );
}

MainView.propTypes = {
  signOut: PropTypes.func.isRequired,
};

export default MainView;
